<template>
    <v-bottom-navigation app v-model="value" class=" d-flex mobile-navigation-bottom" color="black" fixed>
        <v-btn @click="gotoNaviagtionTo('/')">

            <span class="">หน้าหลัก</span>
            <!-- <img class="icon mr-0" src="@/assets/images/icons/home.svg" alt="" /> -->
            <v-icon color="">
                mdi-home-circle-outline
            </v-icon>
        </v-btn>

        <v-btn @click="gotoNaviagtionTo('/payment')">
            <span>ฝาก - ถอน</span>

            <v-icon color="">
                mdi-cash-multiple
            </v-icon>
        </v-btn>

        <!-- <v-btn to="/cart">
      <span>ฉัน</span>
      <v-icon color="">
        mdi-account-circle-outline
      </v-icon>
    </v-btn> -->
        <v-btn @click="gotoNaviagtionTo('/menu')" class="center-btn">
            <span class="text-white">ฉัน</span>
            <v-icon large color="white">mdi-account</v-icon>
        </v-btn>

        <v-btn @click="gotoNaviagtionTo('/contact')">
            <span>ติดต่อเรา</span>
            <v-icon color="">
                mdi-book-open-blank-variant
            </v-icon>
            <!-- <img class="icon mr-0" src="@/assets/images/icons/user-2.svg" alt="" /> -->
        </v-btn>

        <v-btn @click="gotoNaviagtionTo('/promotion')">
            <span>โปรโมชั่น</span>
            <v-icon class="" color="">
                mdi-bullhorn-outline
            </v-icon>

            <!-- <img class="icon mr-0" src="@/assets/images/icons/user-2.svg" alt="" /> -->
        </v-btn>
    </v-bottom-navigation>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { createToastInterface } from 'vue-toastification';
export default {
    data: () => ({ value: 1 }),

    computed: {
        ...mapGetters(['getIsLogin']),
        //   color () {
        //     switch (this.value) {
        //       case 0: return 'blue-grey'
        //       case 1: return 'teal'
        //       case 2: return 'brown'
        //       case 3: return 'indigo'
        //       default: return 'blue-grey'
        //     }
        //   },
    },
    methods : {
        ...mapActions(['logout', 'setModalLogin']),
        gotoNaviagtionTo(path) {
            if (['/payment', '/contact', '/promotion'].indexOf(path) != -1) {
                if (!this.getIsLogin) {
                    createToastInterface().error('กรุณาเข้าสู่ระบบก่อนใช้งาน')
                    return
                }
            }
            this.$router.push(path)
        }
    }
}
</script>
<style lang="scss">
.mobile-navigation-bottom {
    bottom: 0;
    z-index: 100 !important;
}

.center-btn {
    border-radius: 50% !important;
    width: 65px !important;
    height: 65px !important;
    bottom: 14px !important;
    background: linear-gradient(180deg, rgba(65, 66, 65, 1) 0%, rgba(1, 1, 1, 1) 100%) !important;
    color: white !important;
    border: solid 3px #edd184 !important;

}

.center-btn.theme--light.v-bottom-navigation .v-btn:not(.v-btn--active) {
    color: white !important;
}
</style>
